import React from 'react';
import { Route, Switch } from 'react-router-dom';

import {
	ForgotPassword,
	Login,
	SteelHome,
	SteelSmelterInfo,
	SteelSmelters,
	SteelSmeltersCapacity,
	SteelSmeltersProduction,
	SteelSmeltersProductionSubsites,
	SteelSmeltersCO2Emissions,
	SteelSmeltersMap,
	NotFound,
	SignUp,
	SignUpConfirmation,
	IronOre,
	ScrapSteel,
	CuIndices,
	CuHome,
	CuSmeltersMap,
	CuSmeltersProduction,
	CuSmeltersCapacity,
	NiIndices,
	NiHome,
	NiSmeltersMap,
	NiSmeltersProduction,
	NiSmeltersCapacity,
	AlIndices,
	AlHome,
	AlSmeltersMap,
	AlSmeltersProduction,
	AlSmeltersCapacity
} from 'screens';
import { AppliedRoute } from 'components';
// import { getGroupsPerType } from './utils';

export default ({ childProps }) => (
	<Switch>
		<AppliedRoute
			path="/"
			exact
			component={Login}
			props={childProps}
			noTemplate={true}
			insecure={true}
		/>

		<AppliedRoute
			path="/signUp"
			exact
			component={SignUp}
			props={childProps}
			noTemplate={true}
			insecure={true}
		/>
		<AppliedRoute
			path="/signUpConfirmation"
			exact
			component={SignUpConfirmation}
			props={childProps}
			noTemplate={true}
			insecure={true}
		/>
		<AppliedRoute
			path="/forgotPassword"
			exact
			component={ForgotPassword}
			props={childProps}
			noTemplate={true}
			insecure={true}
		/>

		{/* Steel routes */}
		<AppliedRoute
			path="/steel/home"
			exact
			component={SteelHome}
			props={childProps}
			type="steel"
		/>
		<AppliedRoute
			path="/steel/smelterInfo"
			exact
			component={SteelSmelterInfo}
			props={childProps}
			// groupProtect={getGroupsPerType('steel')}
			type="steel"
		/>
		<AppliedRoute
			path="/steel/index"
			exact
			component={SteelSmelters}
			props={childProps}
			type="steel"
		/>
		<AppliedRoute
			path="/steel/capacity"
			exact
			component={SteelSmeltersCapacity}
			props={childProps}
			type="steel"
		/>
		<AppliedRoute
			path="/steel/production/sites"
			exact
			component={SteelSmeltersProduction}
			props={childProps}
			type="steel"
		/>
		<AppliedRoute
			path="/steel/production/subsites/:sType"
			exact
			component={SteelSmeltersProductionSubsites}
			props={childProps}
			type="steel"
		/>
		<AppliedRoute
			path="/steel/co2Emissions"
			exact
			component={SteelSmeltersCO2Emissions}
			props={childProps}
			type="steel"
		/>
		<AppliedRoute
			path="/steel/smeltersMap/:regionKey?"
			exact
			component={SteelSmeltersMap}
			props={childProps}
			// groupProtect={getGroupsSalesEnterprise('steel')}
			type="steel"
		/>
		<AppliedRoute
			path="/ironOre/index"
			exact
			component={IronOre}
			props={childProps}
			type="ironOre"
			alias="fe"
		/>
		<AppliedRoute
			path="/scrapSteel/index"
			exact
			component={ScrapSteel}
			props={childProps}
			type="scrapSteel"
			alias="scrap_steel"
		/>
		{/* Cu routes */}
		<AppliedRoute
			path="/cu/index"
			exact
			component={CuIndices}
			props={childProps}
			type="cu"
		/>
		<AppliedRoute
			path="/cu/capacity"
			exact
			component={CuSmeltersCapacity}
			props={childProps}
			type="cu"
		/>
		<AppliedRoute
			path="/cu/home"
			exact
			component={CuHome}
			props={childProps}
			type="cu"
		/>
		<AppliedRoute
			path="/cu/smeltersMap/:regionKey?"
			exact
			component={CuSmeltersMap}
			props={childProps}
			type="cu"
		/>
		<AppliedRoute
			path="/cu/production"
			exact
			component={CuSmeltersProduction}
			props={childProps}
		/>
		{/* Ni routes */}
		<AppliedRoute
			path="/ni/index"
			exact
			component={NiIndices}
			props={childProps}
			type="ni"
		/>
		<AppliedRoute
			path="/ni/capacity"
			exact
			component={NiSmeltersCapacity}
			props={childProps}
			type="ni"
		/>
		<AppliedRoute
			path="/ni/home"
			exact
			component={NiHome}
			props={childProps}
			type="ni"
		/>
		<AppliedRoute
			path="/ni/smeltersMap/:regionKey?"
			exact
			component={NiSmeltersMap}
			props={childProps}
			type="ni"
		/>
		<AppliedRoute
			path="/ni/production"
			exact
			component={NiSmeltersProduction}
			props={childProps}
			type="ni"
		/>
		{/* Al routes */}
		<AppliedRoute
			path="/al/index"
			exact
			component={AlIndices}
			props={childProps}
			type="al"
		/>
		<AppliedRoute
			path="/al/capacity"
			exact
			component={AlSmeltersCapacity}
			props={childProps}
			type="al"
		/>
		<AppliedRoute
			path="/al/home"
			exact
			component={AlHome}
			props={childProps}
			type="al"
		/>
		<AppliedRoute
			path="/al/smeltersMap/:regionKey?"
			exact
			component={AlSmeltersMap}
			props={childProps}
			type="al"
		/>
		<AppliedRoute
			path="/al/production"
			exact
			component={AlSmeltersProduction}
			props={childProps}
			type="al"
		/>
		<Route component={NotFound} />
	</Switch>
);
